<script>
export default {
  name: "ConfirmTab",
  props: {
    confirmed: Boolean
  }
}
</script>

<template>
  <div class="out" :class="{
      'success': confirmed,
    }">
    <i class="sr sr-check checkIcon mt-1 mr-1"/>
    <div class="sign-card" :class="{
      'success': confirmed,
    }">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.out {
  border-bottom-width: 8px;
}

.sign-card {
  min-height: 100%;
}
</style>